import {LeaveTypesList} from "./LeaveTypesList";
import {LeaveTypesEdit} from "./LeaveTypesEdit";
import {LeaveTypesCreate} from "./LeaveTypesCreate";

export default {
    list: LeaveTypesList,
    create: LeaveTypesCreate,
    edit: LeaveTypesEdit
};
